
import BusinessContinuityExport_DynamicSectionController from './dynamic_section_controller'

export default class BusinessContinuityExport_PlanDeactivationProceduresController extends BusinessContinuityExport_DynamicSectionController {
  // no-op
}
